var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthernet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 208V432C512 440.75 504.75 448 496 448H416V320H384V448H320V320H288V448H224V320H192V448H128V320H96V448H16C7.25 448 0 440.75 0 432V208C0 199.25 7.25 192 16 192H64V144C64 135.25 71.25 128 80 128H128V80C128 71.25 135.25 64 144 64H368C376.75 64 384 71.25 384 80V128H432C440.75 128 448 135.25 448 144V192H496C504.75 192 512 199.25 512 208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernet);
export default __webpack_public_path__ + "static/media/ethernet.5443cb00a04fb75d89e9d2a8149498be.svg";
export { ForwardRef as ReactComponent };